var React = require('react');

function FlagAx (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 423.724H8.828A8.829 8.829 0 010 414.896V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828v317.792a8.83 8.83 0 01-8.829 8.828z","fill":"#4173cd","key":0}),React.createElement("path",{"fill":"#ffe15a","d":"M512 211.862H229.517V88.276h-88.276v123.586H0v88.276h141.241v123.586h88.276V300.138H512z","key":1}),React.createElement("path",{"fill":"#ff4b55","d":"M512 238.345H203.034V88.276h-35.31v150.069H0v35.31h167.724v150.069h35.31V273.655H512z","key":2})]);
}

FlagAx.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagAx;

FlagAx.default = FlagAx;
